import { createContext, useContext, useState, useEffect } from "react";

// Local imports
import { useAuth } from './AuthContext';
import { api } from '../api';

const AssignedVideosContext = createContext(null);

export const AssignedVideosProvider = ({children}) => {
    const [videosCount, setvideosCount] = useState([]);
    const { isLoggedIn, isAdmin } = useAuth();

    useEffect(() => {
        // Check if user has assigned videos
        if (isLoggedIn && !isAdmin) {
            const assignedVideos = async () => {
                try {
                    const {count} = await api.get('/participant/videos/count');
                    setvideosCount(count || 0);
                } catch (err) {
                    console.error('Error fetching assigned videos count:', err);
                    setvideosCount(0);
                }
            }
            assignedVideos();
        }
    }, [isLoggedIn, isAdmin])
    

    return (
        <AssignedVideosContext.Provider value={{videosCount, setvideosCount}}>
            {children}
        </AssignedVideosContext.Provider>
    )
}

export const useAssignedVideos = () => {
    const context = useContext(AssignedVideosContext);
    if (!context) {
        throw new Error('useAssignedVideos must be used within an AssignedVideosProvider');
    }
    return context;
};